import React, { useEffect, useState } from "react";
import {
  usePayOrderMutation,
  useGetPayPalClientIdQuery,
} from "../redux/api/orderApi";
import { toast } from "react-toastify";
import { PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";
import Loader from "./Loader";
import {useNavigate} from "react-router-dom";

function Paypal({ refetch, totalAmount, orderId, paymentInfo }) {
  const [payOrder, { isLoading: loadingPay }] = usePayOrderMutation();
  const [{ isPending }, paypalDispatch] = usePayPalScriptReducer();
  const [isPaid, setIsPaid] = useState(false);
  const navigate = useNavigate();

  // Fetch PayPal client ID
  const {
    data: paypal,
    isLoading: loadingPayPal,
    error: errorPayPal,
  } = useGetPayPalClientIdQuery();

  useEffect(() => {
    if (!errorPayPal && !loadingPayPal && paypal?.clientId) {
      paypalDispatch({
        type: "resetOptions",
        value: {
          "client-id": paypal.clientId,
          currency: "USD",
        },
      });
      paypalDispatch({ type: "setLoadingStatus", value: "pending" });
    }
  }, [paypal, paypalDispatch, errorPayPal, loadingPayPal]);

  useEffect(() => {
    setIsPaid(paymentInfo?.status === "Paid");
  }, [paymentInfo]);

  // Payment success handler function
  const onApprove = async (data, actions) => {
    try {
      const details = await actions.order.capture();
      if (details.status === "COMPLETED") {
        await payOrder({
          orderId,
          details: {
            isPaid: true,
            paymentInfo: {
              status: "Paid",
            },
          },
        });
        setIsPaid(true);
      }
      refetch();
      toast.success("Payment successful");
      navigate("/order_success");
    } catch (err) {
      toast.error(err.data?.message || err.message);
    }
  };

  // Error handling
  function onError(err) {
    toast.error(err.message);
  }

  // Create the order
  function createOrder(data, actions) {
    return actions.order.create({
      purchase_units: [
        {
          amount: {
            value: totalAmount,
          },
        },
      ],
    });
  }

  return (
    <div className="bg-white p-4 rounded-lg shadow">
      <h2 className="text-lg font-semibold mb-3">Payment:</h2>
      {loadingPay && <Loader />}

      {isPending ? (
        <Loader />
      ) : (
        <div className="mt-4 flex flex-col gap-2">
          <PayPalButtons
            style={{ layout: "vertical" }}
            createOrder={createOrder}
            onApprove={onApprove}
            onError={onError}
            disabled={isPaid} // Disable the button if payment is already made
          />
        </div>
      )}
    </div>
  );
}

export default Paypal;
